// extracted by mini-css-extract-plugin
export var addToCartButton = "_tg-b";
export var arrowButtonContainer = "_tg-9";
export var arrowButtonIcon = "_tg-a";
export var carouselArrowButton = "_tg-6";
export var carouselElementContainer = "_tg-1";
export var left = "_tg-7";
export var productDisplayCarouselContainer = "_tg-0";
export var productTileContainer = "_tg-2";
export var productTileImage = "_tg-4";
export var productTileImageContainer = "_tg-3";
export var productTileTitle = "_tg-5";
export var right = "_tg-8";
export var sliderOverflow = "_tg-c";